import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const DriverRequest = Loadable({
  loader: () => import("./driverRequest"),
  loading: TopBarProgress,
});
const IndriveRegister = Loadable({
  loader: () => import("./indrive-register"),
  loading: TopBarProgress,
});
const DidiRegister = Loadable({
  loader: () => import("./didi-register"),
  loading: TopBarProgress,
});
const ClientRequest = Loadable({
  loader: () => import("./clientRequest"),
  loading: TopBarProgress,
});
const DriverRequestLP = Loadable({
  loader: () => import("./driverRequest/landing-page"),
  loading: TopBarProgress,
});
const DeliveryTracking = Loadable({
  loader: () => import("./deliveryTracking"),
  loading: TopBarProgress,
});
const Privacy = Loadable({
  loader: () => import("./privacy"),
  loading: TopBarProgress,
});
const Terms = Loadable({
  loader: () => import("./terms-conditions"),
  loading: TopBarProgress,
});
const ParcelTracking = Loadable({
  loader: () => import("./parcelTracking"),
  loading: TopBarProgress,
});
const Public = () => {
  return (
    <Switch>
      <Route path="/public/parcelTracking">
        <ParcelTracking />
      </Route>
      <Route path="/public/driverRequest">
        <DriverRequest />
      </Route>
      <Route path="/public/indrive">
        <IndriveRegister />
      </Route>
      <Route path="/public/didi">
        <DidiRegister />
      </Route>
      <Route path="/public/driverLP">
        <DriverRequestLP />
      </Route>
      <Route path="/public/tracking">
        <DeliveryTracking />
      </Route>
      <Route path="/public/privacy">
        <Privacy />
      </Route>
      <Route path="/public/terms">
        <Terms />
      </Route>
      <Route path="/public/clientRequest">
        <ClientRequest />
      </Route>

      <Redirect to="/login" />
    </Switch>
  );
};

export default Public;
